import { render } from "./CommentReportModal.vue?vue&type=template&id=7f43f0a1"
import script from "./CommentReportModal.vue?vue&type=script&lang=js"
export * from "./CommentReportModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__